'use client';

import { useEffect, useState, useRef } from 'react';
import { FaStar, FaChevronLeft, FaChevronRight, FaQuoteLeft, FaPencilAlt } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import SectionHeading from '../ui/SectionHeading';
import Card from '../ui/Card';
import ReviewModal from '../ReviewModal';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const reviews = [
  {
    id: 1,
    name: 'Shuhada',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '1 year on Airbnb',
    date: 'April 2024',
    rating: 4,
    comment: 'tempat bersih dan tersusun'
  },
  {
    id: 2,
    name: 'Syahreena',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '10 years on Airbnb',
    date: 'April 2024',
    rating: 5,
    comment: "We had a great one-night stay here at Khairul's place. The place is really clean, so comfortable for our family. It is near to my husband's hometown. The host is always responsive and acts quickly upon request. Deposit returned promptly with no issue and I highly recommend you this place if you are in Segamat. We will come back and stay here for our next Segamat visit."
  },
  {
    id: 3,
    name: 'Sakila',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '3 years on Airbnb',
    date: 'March 2024',
    rating: 5,
    comment: 'house was nice... beyond expectation!'
  },
  {
    id: 4,
    name: 'Siti Khalijah',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '7 years on Airbnb',
    date: 'December 2024',
    rating: 5,
    comment: 'Host is very understanding. Much appreciated. The unit is also in excellent condition. Nothing much to say. You guys need to stay here for the experience!'
  },
  {
    id: 5,
    name: 'Ungku Hatta',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '6 years on Airbnb',
    date: 'October 2024',
    rating: 5,
    comment: 'Khairul homestay is super clean n tidy. Spacious and comfortable for us with 8 people to stay. Extra blanket n pillows are very well appreciated. Ammeneties are fully complete... Everything is there for you.. Feel just like home. We are 100% will stay here again if we are in Segamat. Thank you for providing such comfortable place to stay.'
  },
  {
    id: 6,
    name: 'Haniss Nadhirah',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '4 years on Airbnb',
    date: 'April 2025',
    rating: 5,
    comment: 'Book 3 hari dua malam . Stay up alang2 hantar adik masuk study.. Alhamdulillah everythings was great.. very very comfy & tidy , feel like self home . Siap ada bilik solat .. respect pada owner .'
  },
  {
    id: 7,
    name: 'Sam',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '2 years on Airbnb',
    date: 'January 2025',
    rating: 5,
    comment: 'great location and clean stay, the neighbors is quite safe and bright too. will definitely stay here again!'
  },
  {
    id: 8,
    name: 'Halsaran',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '1 year on Airbnb',
    date: 'September 2024',
    rating: 5,
    comment: 'Had a great stay. felt like staying in home. The location is also very strategic and not too far from Segamat town. There are few restaurants, gym nearby and even Pharmacy. what\'s more interesting is that there is also Billion Super market nearby. Would consider to revisit again if i visit Segamat again'
  },
  {
    id: 9,
    name: 'Azreen',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '9 years on Airbnb',
    date: 'August 2024',
    rating: 5,
    comment: 'We had a great stay at this Airbnb. The house matched the pictures and description perfectly and is located in a pleasant neighborhood. The porch conveniently fits 2-3 cars, and the house is easy to find with clear instructions provided. The property is clean and well-decorated, with air conditioning in the living room and all three bedrooms. It comfortably accommodates more than 10 people and is equipped with a Cuckoo water dispenser and complete kitchen utensils and appliances. It offers excellent value for the money, and we would definitely choose to stay here again in Segamat.'
  },
  {
    id: 10,
    name: 'Nurulizzatie',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '6 months on Airbnb',
    date: 'January 2025',
    rating: 5,
    comment: 'sangat selesa . rumah bersih cantik . sangat2 terbaik . macamana di gambar macam tu lah selesanya rumah . kemas . kalau ke segamat pasti akan repeat lagi . tuan rumah pun cepat respon bila wasap . terima kasih tuan rumah .😊'
  },
  {
    id: 11,
    name: 'Taufiq',
    avatar: '/images/avatars/default-avatar.jpg',
    years: '9 years on Airbnb',
    date: 'January 2025',
    rating: 5,
    comment: 'Excellent unit , good location and host.'
  }
];

interface GuestReviewsProps {
  isAuthenticated?: boolean;
  openReviewModal?: () => void;
}

export default function GuestReviews({ isAuthenticated = false, openReviewModal }: GuestReviewsProps) {
  // Fixed rating at 5.0 as requested
  const averageRating = 5.0;
  const [mounted, setMounted] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);
  
  // Handle client-side mounting for Swiper
  useEffect(() => {
    setMounted(true);
    
    // Debug: Log when component mounts
    console.log('GuestReviews component mounted, isReviewModalOpen:', isReviewModalOpen);
  }, []);
  
  // Debug: Log when modal state changes
  useEffect(() => {
    console.log('Modal state changed to:', isReviewModalOpen);
  }, [isReviewModalOpen]);
  
  return (
    <>
      <SectionHeading 
        title="Guest Reviews" 
        subtitle={`See what our ${reviews.length} guests have to say about their stay at Mikhael Homestay`}
      />
      
      <motion.div 
        className="w-full"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <motion.div 
          className="flex justify-center mb-10 flex-col sm:flex-row items-center gap-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Card className="flex items-center px-6 py-3 bg-gradient-to-r from-blue-50 to-blue-100 border-none">
            <div className="flex mr-3">
              {[...Array(5)].map((_, i) => (
                <motion.div 
                  key={i}
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: i * 0.1, duration: 0.3 }}
                >
                  <FaStar 
                    className="text-yellow-400" 
                    size={22} 
                  />
                </motion.div>
              ))}
            </div>
            <span className="font-bold text-gray-900 text-lg">{averageRating.toFixed(1)}</span>
            <span className="mx-2 text-gray-500">·</span>
            <span className="text-gray-700">{reviews.length} reviews</span>
          </Card>
          
          <motion.button
            onClick={() => {
              console.log('Review button clicked');
              if (openReviewModal) {
                openReviewModal();
              } else {
                setIsReviewModalOpen(true);
              }
            }}
            className="flex items-center px-5 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-sm hover:shadow-md transition-all"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
          >
            <FaPencilAlt className="mr-2" />
            Leave a Review
          </motion.button>
        </motion.div>
        
        <motion.div 
          className="relative px-4 py-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {/* Custom navigation buttons */}
          <motion.div 
            ref={prevRef}
            className="swiper-button-prev absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-soft p-4 cursor-pointer hover:bg-gray-50 transition-all hidden md:flex items-center justify-center"
            whileHover={{ scale: 1.1, backgroundColor: "#f8fafc" }}
            whileTap={{ scale: 0.95 }}
          >
            <FaChevronLeft className="text-gray-700" size={16} />
          </motion.div>
          <motion.div 
            ref={nextRef}
            className="swiper-button-next absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-soft p-4 cursor-pointer hover:bg-gray-50 transition-all hidden md:flex items-center justify-center"
            whileHover={{ scale: 1.1, backgroundColor: "#f8fafc" }}
            whileTap={{ scale: 0.95 }}
          >
            <FaChevronRight className="text-gray-700" size={16} />
          </motion.div>
          
          {mounted && (
            <Swiper
              modules={[Navigation, Pagination, Autoplay, A11y]}
              spaceBetween={32}
              slidesPerView={1}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                }
              }}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 6000,
                disableOnInteraction: false,
              }}
              loop={true}
              className="reviews-swiper"
              onBeforeInit={(swiper) => {
                // @ts-ignore
                swiper.params.navigation.prevEl = prevRef.current;
                // @ts-ignore
                swiper.params.navigation.nextEl = nextRef.current;
              }}
            >
              {reviews.map((review, index) => (
                <SwiperSlide key={review.id}>
                  <Card className="h-full p-0 overflow-hidden">
                    <div className="p-6 h-full flex flex-col">
                      <div className="flex items-center mb-5">
                        <div className="relative w-14 h-14 rounded-full overflow-hidden mr-4 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center shadow-sm">
                          <div className="text-2xl font-bold text-blue-600">{review.name.charAt(0)}</div>
                        </div>
                        <div>
                          <h3 className="font-semibold text-gray-900 text-lg">{review.name}</h3>
                          <div className="flex items-center">
                            <p className="text-sm text-gray-500">{review.date}</p>
                            <span className="mx-2 text-gray-300">•</span>
                            <p className="text-sm text-gray-500">{review.years}</p>
                          </div>
                        </div>
                      </div>
                      
                      <div className="flex mb-4">
                        {[...Array(5)].map((_, i) => (
                          <FaStar 
                            key={i} 
                            className={i < review.rating ? 'text-yellow-400' : 'text-gray-200'} 
                            size={18} 
                          />
                        ))}
                      </div>
                      
                      <div className="relative flex-grow">
                        <FaQuoteLeft className="text-blue-100 absolute top-0 left-0 text-opacity-50" size={24} />
                        <p className="text-gray-700 pl-8 pr-2 italic">{review.comment}</p>
                      </div>
                    </div>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </motion.div>
        
        <style>{`
          .swiper-pagination {
            position: relative;
            margin-top: 32px;
          }
          .swiper-pagination-bullet {
            width: 10px;
            height: 10px;
            background: #e2e8f0;
            opacity: 1;
            transition: all 0.3s ease;
          }
          .swiper-pagination-bullet-active {
            background: #3b82f6;
            transform: scale(1.2);
          }
          .swiper-button-prev:after,
          .swiper-button-next:after {
            display: none;
          }
          .reviews-swiper {
            padding: 8px 4px 32px 4px;
          }
        `}</style>
      </motion.div>
      
      {/* Direct Modal Implementation */}
      {isReviewModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => setIsReviewModalOpen(false)}></div>
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 z-10">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold">{isAuthenticated ? 'Leave a Review' : 'Sign In Required'}</h3>
              <button 
                onClick={() => setIsReviewModalOpen(false)}
                className="p-1 rounded-full hover:bg-gray-100"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {isAuthenticated ? (
              <div className="space-y-4">
                <p>This is the review form for authenticated users.</p>
                <div className="flex justify-end">
                  <button 
                    onClick={() => setIsReviewModalOpen(false)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md"
                  >
                    Close
                  </button>
                </div>
              </div>
            ) : (
              <div className="space-y-4">
                <p>Please sign in to leave a review.</p>
                <div className="flex justify-end">
                  <button 
                    onClick={() => setIsReviewModalOpen(false)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
